/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Text } from '@mantine/core';
import classes from './Table.module.css';
import clsx from 'clsx';
import { truncateString, uuid } from '@utils/functions';
import { Tooltip } from '@components/atoms/Tooltip';
import { useTranslation } from 'react-i18next';

const Table = (props: { rows: any }) => {
	const { t } = useTranslation();
	return (
		<Box className={classes.table}>
			<Box className={classes.header}>
				<Box className={classes.cell}>
					<Text className={classes.title}>
						{t('global.project')}
					</Text>
				</Box>
				<Box className={classes.cell}>
					<Text className={classes.title}>
						{t('global.pricePerTco2e')}
					</Text>
				</Box>
				<Box className={classes.cell}>
					<Text className={classes.title}>
						{' '}
						{t('global.quantity')}
					</Text>
				</Box>
				<Box
					className={clsx(classes.cell, classes.cellEnd)}
				>
					<Text className={classes.title}>
						{' '}
						{t('global.total')}
					</Text>
				</Box>
			</Box>
			{props.rows &&
				props.rows.map((item: any) => (
					<Box key={uuid()} className={classes.row}>
						<Tooltip
							isActive={
								item.name && item.name.length > 14
							}
							label={item && item.name ? item.name : ''}
						>
							<Box className={classes.cell}>
								<Text className={classes.value}>
									{truncateString(item.name, 14)}
								</Text>
							</Box>
						</Tooltip>
						<Box className={classes.cell}>
							<Text className={classes.value}>
								{item.price}
							</Text>
						</Box>
						<Box className={classes.cell}>
							<Text className={classes.value}>
								{item.quantity}
							</Text>
						</Box>
						<Box
							className={clsx(
								classes.cell,
								classes.cellEnd
							)}
						>
							<Text className={classes.value}>
								{item.total}
							</Text>
						</Box>
					</Box>
				))}
		</Box>
	);
};

export default Table;
